import { EChatDateGroupKind } from "../types/chat-date-group";

// NOTE: NSAI-4559 — widths of the two rolling sidebar buckets, counted in whole
// local days back from today's midnight.
export const CHAT_DATE_GROUP_WEEK_DAYS = 7 as const;

export const CHAT_DATE_GROUP_MONTH_DAYS = 30 as const;

// NOTE: Only the fixed buckets need a translation key — MONTH and YEAR labels
// come from Intl, so they map to an empty key and never reach `translate`.
export const CHAT_DATE_GROUP_LABEL_KEYS: Record<EChatDateGroupKind, string> = {
  [EChatDateGroupKind.TODAY]: "chat_list.groups.today",
  [EChatDateGroupKind.YESTERDAY]: "chat_list.groups.yesterday",
  [EChatDateGroupKind.PREVIOUS_7_DAYS]: "chat_list.groups.previous_7_days",
  [EChatDateGroupKind.PREVIOUS_30_DAYS]: "chat_list.groups.previous_30_days",
  [EChatDateGroupKind.MONTH]: "",
  [EChatDateGroupKind.YEAR]: "",
};
